module.exports = __webpack_public_path__ + "img/tbk-logo-white.026bf0d0.svg";